import {
  MAX_MENTIONS_PER_REQUEST,
  Mention,
} from '@design/chat/mention-composer';

export const toRequestMentions = (
  mentions: Mention[] | undefined
): Mention[] | undefined => {
  const filtered = (mentions ?? [])
    .filter(mention => !mention.type.startsWith('insight'))
    .slice(0, MAX_MENTIONS_PER_REQUEST);

  return filtered.length ? filtered : undefined;
};
